import { MAX_COLUMNS } from "../constants";

export function getNumberOfColsMobile(length) {
    if (length >= 1 && length <= 3) {
        return length;
    } else if (length > MAX_COLUMNS) {
        return 1;
    } else if (length % 2 === 0) {
        return 2;
    } else {
        return 1;
    }
}
